// extracted by mini-css-extract-plugin
export default {"form":"form____kVkB","logo":"logo___Mww8A","header":"header___Cfkrq","forgot":"forgot___Mftz8"};